import Vue from 'vue'
import restConfig from './config'

Vue.prototype.$rest = restConfig

export default restConfig
